<template>
    <div class="flex items-center">

        <a
            v-if="clickable"
            :title="title"
            href="#reviews"
            class="flex items-center no-underline"
        >
            <StarFilledIcon class="h-3 w-3 text-orange-light mr-2" />
            <div class="text-sm font-semibold">
                <span class="text-orange-light">{{ score }}</span>
                <span class="text-grey">({{ count }})</span>
            </div>
        </a>
        <div
            v-else-if="count > 0"
            :title="title"
            class="flex items-center"
        >
            <StarFilledIcon class="h-3 w-3 text-orange-light mr-2" />
            <div class="text-sm font-semibold">
                <span class="text-orange-light">{{ score }}</span>
                <span class="text-grey">({{ count }})</span>
            </div>
        </div>

        <div
            v-else
            class="text-sm font-semibold text-grey"
        >
            No reviews.
        </div>

    </div>
</template>

<script>
import StarFilledIcon from '~/static/fonts/LineIcons/star-filled.svg';

export default {

    components: {
        StarFilledIcon,
    },

    props: {
        productId: {
            type: Number,
            required: true,
        },
        score: {
            type: String,
            required: true,
        },
        count: {
            type: Number,
            required: true,
        },
        clickable: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        title() {
            const noun = this.score === 1 ? 'star' : 'stars';
            return `${this.score} ${noun} (${this.count} reviews)`;
        },
    },

};
</script>

<style lang="scss" scoped>
.hover-opacity {
    @apply transition-fast;
    &:hover {
        @apply opacity-75;
    }
}
</style>
